<div class="component-wrapper">
    <form class="form" (ngSubmit)=preRegister() [formGroup]="preRegistrationForm">
        <div class="email">
            <kendo-formfield>
                <kendo-label class="form-label" [for]="benutzername" translate>auth.email</kendo-label>
                <kendo-textbox #benutzername [placeholder]="'auth.email' | translate" formControlName="email"
                    showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of benutzernameErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <div class="datenschutz">
            <kendo-formfield>
                <div class="k-checkbox-wrap">
                    <input id="datenschutz" #datenschutz type="checkbox" kendoCheckBox formControlName="datenschutz"
                        [attr.aria-label]="'pre-register.privacyAgreement' | translate:{linkDatenschutzbestimmung}"/>
                    <label for="datenschutz" class="k-checkbox-label"
                        [innerHTML]="'pre-register.privacyAgreement' | translate:{linkDatenschutzbestimmung}">
                    </label>
                </div>                
                <kendo-formerror *ngFor="let errorMessage of datenschutzErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <label class="login">{{ 'pre-register.alreadyRegistered' | translate}}&nbsp;
            <a [routerLink]="['/authentication/login']" translate>auth.login</a>
        </label>

        <captcha-component formControlName="captchaChallengeResponse"></captcha-component>

        <div class="submit-wrapper">
            <button kendoButton class="preRegister" type="submit" [disabled]="preRegistrationForm.invalid || isLoading"
                [innerHTML]="'auth.pre_register' | translate"></button>
        </div>
    </form>
</div>